import { OfferService } from "@/services/offer.service";
import { StorageService } from "@/services/storage.service";
import store from "@/store";

const state = () => ({
  list: [],
  favorites: [],
  details: StorageService.get("offerDetails") || {},
  page: 0,
  orderBy: "arrival_date",
  sortDir: "desc",
  page_count: 50,
  total_pages_count: 0,
  pageLoading: false,
  filters: StorageService.get("offerFilters") || {
    patient: 1,
    gender: 0,
    other_people_in_household: false,
    mobility: {
      wheelchair: false,
      bedridden: false,
      mobile: false
    },
    night_work: {
      little: false,
      medium: false,
      much: false
    },
    dementia: {
      no_to_mild: false,
      advanced: false
    },
    desired_min_salary: 0,
    favorable_place: 1,
    residential_area: {
      urban: false,
      rural: false
    },
    car_trips: {
      no: false,
      yes: false
    },
    accommodation: {
      house: false,
      apartment: false,
      own_room: false
    }
  },
  dropDown: StorageService.get("filterDropdown") || {}
});

const getters = {
  list: state => state.list,
  favorites: state => state.favorites,
  details: state => state.details,
  orderBy: state => state.orderBy,
  sortDir: state => state.sortDir,
  filters: state => state.filters,
  dropDown: state => state.dropDown,
  total_pages_count: state => state.total_pages_count,
  pageLoading: state => state.pageLoading,

};

const actions = {


  list({ commit, state }) {
    return OfferService.fetchList(state.page)
      .then(res => {
        commit("setList", { data: res.data, toDo: "list" });

        return true;
      })
      .catch(() => {
        return false;
      });
  },
  list1({ commit, state }) {
    return OfferService.favorites(state.orderBy, state.sortDir)
      .then(res => {

        commit("setFavList", res.data);

        return true;
      })
      .catch(() => {
        return false;
      });
  },
  paginate({ commit, state }, pageNo) {
    return OfferService.fetchList(pageNo)
      .then(res => {
        commit("setList", { data: res.data, toDo: "paginate" });
        return true;
      })
      .catch(() => {
        return false;
      });
  },
  details({ commit, state }, offerId) {
    return OfferService.fetchDetails(offerId)
      .then(res => {
        StorageService.save("offerDetails", res.data);
        commit("setDetails", res.data);
        return true;
      })
      .catch(() => {
        return false;
      });
  },
  toggleFav({ commit, dispatch }, { offerId, page, page_count }) {
    return OfferService.toggleFavorite(offerId)
      .then(() => {
        switch (page, page_count) {
          case "list":
            dispatch("list");
            break;
          case "favorites":
            dispatch("favorites");
            break;
          case "details":
            dispatch("details", offerId);
            break;
        }
        return true;
      })
      .catch(() => {
        return false;
      });
  },
  favorites({ commit, state }) {
    return OfferService.favorites(state.orderBy, state.sortDir)
      .then(res => {
        commit("setFavList", res.data);
        return true;
      })
      .catch(() => {
        return false;
      });
  },
  toggleCustomer({ commit, state }, id) {
    return OfferService.toggleCustomer(id)
      .then(res => true)
      .catch(() => false);
  },
  saveFilter({ commit, state, dispatch }) {
    return OfferService.saveFilters(state.filters)
      .then(res => {
        dispatch("list");
        return true;
      })
      .catch(() => false);
  },
  saveFavoriteFilter({ commit, state, dispatch }) {
    return OfferService.saveFilters(state.filters)
      .then(res => {
        dispatch("list1");
        return true;
      })
      .catch(() => false);
  },
  fetchFilters({ commit }) {
    return OfferService.fetchFilters()
      .then(res => {
        commit("setFilters", { data: res.data.filter, toDo: "" });
        commit("setDropdown", res.data);
      })
      .catch(() => false);
  },
  resetFilters({ commit }) {
    return OfferService.resetFilters()
      .then(res => {

        commit("setFilters", { data: res.data.filter, toDo: "resetFilters" });
        commit("setDropdown", res.data);
      })
      .catch(() => false);
  }
};

const mutations = {
 

  updatePageLoading(state, {value}) {
    state.pageLoading = value;
  },
  setList(state, { data, toDo }) {
    if (toDo == "paginate") {

      state.list = state.list.concat(data.missions);
      state.pageLoading = false;

    } else {
      state.list = data.missions;
      state.total_pages_count = Math.ceil(data.total / 50);
      state.pageLoading = false;
    }

  },
  setFavList(state, data) {
    state.favorites = data;
  },
  setDetails(state, data) {
    state.details = data;
  },
  setOrderBy(state, data) {
    state.orderBy = data;
  },
  setSortDir(state, data) {
    state.sortDir = data;
  },
  setFilters(state, { data, toDo }) {
    if (toDo == "resetFilters") {
      state.pageLoading = false
    }
    else {
      state.pageLoading = true

    }
    state.filters = {
      ...state.filters,
      availability_date: store.getters["user/profile"].availability_date,
      ...data
    };
  },
  setDropdown(state, data = {}) {
    delete data.filter;
    state.dropDown = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
